import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useForm, Controller } from 'react-hook-form'
import {
  Table,
  ButtonGroup,
  IconButton,
  Icon,
  Panel,
  Row,
  Form,
  Col,
  Grid,
  Avatar,
  Input,
  ControlLabel,
  SelectPicker,
  Button,
} from 'rsuite'
import pathname from '../../constants/pathname'
import AppContext from '../../context/AppContext'
import { getAllProject, getTest } from '../../redux/actions/dashboard'
import './styles.less'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import TooltipButton from '../../components/buttons/TooltipButton'
import ConfirmWidget from '../confirm/ConfirmWidget'
import {
  isRequired,
  isValidators,
  requiredFiled,
  getMaxLengthData,
} from '../../utils/ValidatorUtils'
import classNames from 'classnames'
import { isEmpty, findIndex } from 'lodash'
import {
  getMasterReservedWord,
  saveMasterReservedWord,
  updateMasterReservedWord,
  deleteMasterReservedWord,
} from '../../redux/actions/masterReservedWord'
import { startLoading, doneLoading } from '../../utils/loading'

export default function TableManage({
  schema,
  subName,
  single,
  onSingleSubmit = () => {},
  muti,
  onMutiSubmit,
  enableView,
  onView,
  onRemove,
  onReload,
  pagination,
  lengthMenu,
  hiddenColStatus,
  searchRows,
  onSearchProject,
  onSelectProject,
  onShow,
  rowCanEdit,
  rowOnSubmit,
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [selectList, setSelectList] = useState([])
  const [isError, setIsError] = useState(false)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [deleteObj, setDeleteObj] = useState({})
  const [displayLength, setDisplayLength] = useState(5)
  const [page, setPage] = useState(1)
  const contextValue = React.useContext(AppContext)
  const [tableData, setTableData] = useState([])
  const [inputValueName, setInputValueName] = useState('')
  const [expand, setExpand] = useState(true)
  const [loading, setloading] = useState(false)

  const [localSchema, setLocalSchema] = useState(schema)

  useEffect(() => {
    setLocalSchema(schema)
    if (pagination && typeof onReload !== 'function') {
      const data = getData(schema, 1, 5)
      setTableData(data)
    } else {
      setTableData(schema.values || [])
    }
  }, [schema, pagination, onReload])

  const defaultPage = 1
  const defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
  ]

  const handleCallApiUpdate = async (request, id) => {
    startLoading()
    setloading(true)
    try {
      const response = await updateMasterReservedWord(id, request)
      console.log('response = ', response)
      if (response) {
        handleSearchProject()
        // setTableData(response?.forms?.tableList?.values)
        // if (pagination && typeof onReload !== 'function') {
        //   setTableData(getData(response?.forms?.tableList, 1, 5))
        // } else {
        //   setTableData(schema.values || [])
        // }
      }
    } catch (e) {
      console.log('e', e)
    }
    setloading(false)
    doneLoading()
  }

  const handleCallApiDelete = async (id) => {
    startLoading()
    setloading(true)
    try {
      const response = await deleteMasterReservedWord(id)

      if (response) {
        handleSearchProject()
      }
    } catch (e) {
      console.log('e', e)
    }
    setloading(false)
    doneLoading()
  }

  const handleChangeLength = (dataKey) => {
    // console.log('handleChangeLength dataKey', dataKey)
    setPage(1)
    setDisplayLength(dataKey)
    if (typeof onReload === 'function') {
      onReload(dataKey, 1, inputValueName)
    } else {
      if (pagination && typeof onReload !== 'function') {
        setTableData(getData(localSchema, 1, dataKey))
      } else {
        setTableData(localSchema?.values || [])
      }
    }
  }

  const handleChangePage = (dataKey) => {
    // console.log('handleChangePage page', dataKey)

    setPage(dataKey)
    if (typeof onReload === 'function') {
      onReload(displayLength, dataKey, inputValueName)
    } else {
      if (pagination && typeof onReload !== 'function') {
        setTableData(getData(localSchema, dataKey, displayLength))
      } else {
        setTableData(localSchema?.values || [])
      }
    }
  }

  const getData = (schema, page, displayLength) => {
    return schema.values?.filter((v, i) => {
      const start = displayLength * (page - 1)
      const end = start + displayLength
      return i >= start && i < end
    })
  }

  const handleChangeSearchValue = (val) => {
    setInputValueName(val)
  }

  const handleSearchProject = () => {
    onSearchProject(5, 1, inputValueName)
    setPage(1)
  }

  const [data, setData] = React.useState(tableData.filter((v, i) => i < 8))

  const handleChange = (id, key, value) => {
    const nextData = Object.assign([], data)
    nextData.find((item) => item.id === id)[key] = value
    // setData(nextData)
  }
  // const handleEditState = (rowData) => {
  //   console.log('rowData', rowData)
  //   const nextData = Object.assign([], tableData)
  //   const activeItem = nextData.find((item) => item.id === rowData.id)
  //   activeItem.status = activeItem.status ? null : 'EDIT'
  //   setData(nextData)
  // }

  const handleChangeEditStatus = (rowData) => {
    console.log('rowData22', rowData)
    var newData = tableData.map((item) => {
      if (item.id === rowData.id) {
        let newItem = {
          ...item,
          status: rowData.status ? null : 'EDIT',
        }
        return newItem
      }
      return item
    })
    console.log('newData', newData)
    setTableData(newData)
  }

  const handleCancelSearchProject = () => {
    setInputValueName('')
    onSearchProject(5, 1, '', '')
    setPage(1)
  }

  const onSubmit = (data, rowData) => {
    console.log('data', data)
    console.log('rowData', rowData)
    let request = {
      word: data[rowData.id],
    }
    handleCallApiUpdate(request, rowData.id)
    //rowOnSubmit(newData)
  }

  const handleDelete = (rowData) => {
    setIsShowConfirm(true)
    setDeleteObj(rowData)
  }

  const EditCell = ({ rowData, dataKey, onChange, ...props }) => {
    const editing = rowData.status === 'EDIT'
    return (
      // <Cell {...props} className={editing ? 'table-content-editing' : ''}>
      //   {editing ? (
      //     <input
      //       className="rs-input"
      //       defaultValue={rowData[dataKey]}
      //       onChange={(event) => {
      //         onChange && onChange(rowData.id, dataKey, event.target.value)
      //       }}
      //     />
      <Cell {...props} className={editing ? 'table-content-editing' : ''}>
        {editing ? (
          <Input
            className={classNames('rs-input', errors[rowData.id] && 'is-error')}
            name={rowData.id}
            defaultValue={rowData[dataKey]}
            inputRef={register(
              isValidators([
                {
                  type: 'REQUIRED',
                  value: null,
                  errorMessage: 'กรุณาเพิ่มคำต้องห้าม',
                },
              ])
            )}
            onChange={(value) => {
              setValue(rowData.id, value)
            }}
          />
        ) : (
          //   <Controller
          //   name={rowData.id}
          //   key={rowData.id}
          //   control={control}
          //   defaultValue={rowData[dataKey]}
          //   rules={{ required: 'กรุณากรอกคำต้องห้าม' }}
          //   render={(props) => {
          //     return (
          //       <Input
          //         className={classNames('rs-input', errors[rowData.id] && 'is-error')}
          //         value={props.value}
          //         onChange={(value) => {
          //           props.onChange(value)
          //         }}
          //       />
          //     )
          //   }}
          // />
          <span className="table-content-edit-span">{rowData[dataKey]}</span>
        )}
      </Cell>
    )
  }

  // console.log('tableData => ', tableData)

  return (
    <>
      <br />
      <Panel
        shaded
        header={schema?.header}
        collapsible
        defaultExpanded
        // ref={(section) => {
        //   setSection(section)
        // }}
      >
        {schema?.searchProhibited && (
          <Grid fluid>
            <Row gutter={16}>
              <Col xs={6}>
                <ControlLabel>{schema.searchProhibited.label}</ControlLabel>
                <Input
                  style={{ width: '100%' }}
                  name={schema.searchProhibited.name}
                  value={inputValueName}
                  placeholder={
                    schema.searchProhibited.hint || `ระบุ${schema.searchProhibited.label}`
                  }
                  onChange={handleChangeSearchValue}
                ></Input>
              </Col>
              <Col xs={6}>
                <div>
                  <br />
                  <Button
                    size="sm"
                    color="green"
                    appearance="ghost"
                    style={{ width: '40%', height: '35px' }}
                    onClick={handleSearchProject}
                  >
                    {schema.searchProhibited.buttonSearchText}
                  </Button>
                  &nbsp;&nbsp;&nbsp;
                  <Button
                    size="sm"
                    color="yellow"
                    appearance="ghost"
                    style={{ width: '40%', height: '35px' }}
                    onClick={handleCancelSearchProject}
                  >
                    {schema.searchProhibited.buttonCancelText}
                  </Button>
                </div>
              </Col>
            </Row>
          </Grid>
        )}

        <Table
          wordWrap
          height={400}
          loading={loading}
          data={tableData}
          // data={pagination && typeof onReload !== 'function' ? getData() : schema.values || []}
          style={{ marginTop: '20px' }}
        >
          <Column align="center" width={70} fixed>
            <HeaderCell>
              <span>{schema.numberText}</span>
            </HeaderCell>
            <Cell>
              {(_, index) => {
                // return index + 1
                return index + 1 + (page * displayLength - displayLength)
              }}
            </Cell>
          </Column>

          <Column flexGrow={1}>
            <HeaderCell>
              <span>{schema.listText}</span>
            </HeaderCell>
            {/* <Cell dataKey="prohibitedName" /> */}
            <EditCell dataKey="wordName" onChange={handleChange} />
          </Column>

          {rowCanEdit ? (
            <Column width={250} align="center" fixed="right">
              <HeaderCell>
                <span></span>
              </HeaderCell>
              {/* <ActionCell dataKey="id" onClick={handleEditState} /> */}
              <Cell>
                {(rowData) => {
                  if (rowData.status === 'EDIT') {
                    return (
                      <ButtonGroup>
                        <IconButton
                          appearance="ghost"
                          icon={
                            <Icon appearance="ghost" icon="save" className="bt-gost-icon-radius" />
                          }
                          onClick={handleSubmit((data) => onSubmit(data, rowData))}
                        >
                          บันทึก
                        </IconButton>
                        <IconButton
                          appearance="ghost"
                          className="rs-btn-ghost-cancel"
                          icon={
                            <Icon
                              appearance="ghost"
                              icon="close"
                              className="bt-gost-icon-none-radius-cancel"
                            />
                          }
                          onClick={() => handleChangeEditStatus(rowData)}
                        >
                          ยกเลิก
                        </IconButton>
                      </ButtonGroup>
                    )
                  } else {
                    return (
                      <ButtonGroup>
                        <IconButton
                          appearance="ghost"
                          className="rs-btn-ghost-edit"
                          icon={
                            <Icon
                              appearance="ghost"
                              icon="edit"
                              className="bt-gost-icon-radius-edit"
                            />
                          }
                          onClick={() => handleChangeEditStatus(rowData)}
                        >
                          แก้ไข
                        </IconButton>
                        <IconButton
                          appearance="ghost"
                          className="rs-btn-ghost-cancel"
                          icon={
                            <Icon
                              appearance="ghost"
                              icon="trash-o"
                              className="bt-gost-icon-none-radius-cancel"
                            />
                          }
                          onClick={() => handleDelete(rowData)}
                        >
                          ลบ
                        </IconButton>
                      </ButtonGroup>
                    )
                  }
                }}
              </Cell>
            </Column>
          ) : (
            <Column width={150} align="center" fixed="right">
              <HeaderCell>
                <span></span>
              </HeaderCell>
              <Cell>
                {(rowData) => {
                  return (
                    <ButtonGroup>
                      <IconButton
                        appearance="ghost"
                        icon={
                          <Icon
                            icon={schema.buttonTable.singleIcon}
                            className="bt-gost-icon-radius"
                          />
                        }
                        onClick={() => {
                          onSelectProject(rowData.projectVersionId)
                        }}
                      >
                        {schema.buttonTable.buttonText}
                      </IconButton>
                    </ButtonGroup>
                  )
                }}
              </Cell>
            </Column>
          )}
        </Table>
        {pagination && (
          <TablePagination
            lengthMenu={lengthMenu || defaultLengthMenu}
            activePage={page || defaultPage}
            renderLengthMenu={(lengthMenu) => {
              return (
                <>
                  {lengthMenu}
                  {`รายการ/หน้า`}
                </>
              )
            }}
            renderTotal={(total) => {
              return <>{` ทั้งหมด ${total} รายการ`}</>
            }}
            displayLength={displayLength || 5}
            total={schema.totalSize}
            onChangePage={handleChangePage}
            onChangeLength={handleChangeLength}
          />
        )}

        {schema?.message && (
          <Row>
            <Message showIcon type={schema.message.type} description={schema.message.message} />
          </Row>
        )}

        <ConfirmWidget
          title={`ยืนยันการลบรายการ`}
          show={isShowConfirm}
          detail={`ยืนยันการลบ ${
            deleteObj?.projectName ? schema.projectNameText + ' : ' + deleteObj.projectName : ''
          }`}
          onCancle={() => {
            setIsShowConfirm(false)
            setDeleteObj({})
          }}
          onConfirm={() => {
            handleCallApiDelete(deleteObj.id)
            let total = schema.values.length
            let newPage = Math.ceil(total / displayLength)
            if (newPage > 0 && newPage < page) {
              setPage(newPage)
            }
            setIsShowConfirm(false)
          }}
        />
      </Panel>
    </>
  )
}
